import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { dictionariesRouting } from "./dictionaries.routing";
import { SharedModule } from "../../core/shared/shared.module";
import { MessageBoxComponent } from "../../core/shared/message-box.component";
import { DictionaryComponent } from "../dictionary/dictionary.component";
import { DictionariesComponent } from "./dictionaries.component";
import { DictionaryRest } from "../dictionary/dictionary.rest";

@NgModule({
  imports: [CommonModule, dictionariesRouting, SharedModule],
  declarations: [DictionaryComponent, DictionariesComponent],
  exports: [DictionaryComponent],
  providers: [DictionaryRest]
})
export class DictionariesModule {}
